/* eslint-disable @typescript-eslint/naming-convention */
// eslint-disable-next-line no-shadow
export enum EulaStatus {
  ACCEPT,
  DECLINE
}
